module.exports = __webpack_public_path__ + "static/media/aslide3.a707c4e2.svg";